<template>
  <div id="card-status-gate">
    <vs-card class="cardBorder-circle">
      <div v-if="Sensor">
        <img src="@/assets/images/i-APC/ggif.gif" />
      </div>
      <div v-else>
        <img src="@/assets/images/i-APC/gateway.png" />
      </div>
    </vs-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      Sensor: true,
      interval: null,
    };
  },
  components: {},
  async mounted() {
    // await this.getStatus();
    // this.interval = setInterval(async () => {
    //   await this.getStatus();
    // }, 60 * 1000);
    this.callData()
  },
  beforeDestroy() {
    clearTimeout(this.interval);
  },
  methods: {
    async callData() {
      await this.getStatus();
      this.interval = setTimeout(async () => {
        await this.callData();
      }, 60 * 1000);
    },
    async getStatus() {
      let allsensor = await this.$API.get("sensors/user");
      if (allsensor.status == 200) {
        console.log(allsensor);
        for (let i = 0; i < allsensor.data.length; i++) {
          const el = allsensor.data[i];
          if (el.subtype == "rfid") {
            this.Sensor = el.active == 1 ? true : false;
          }
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.cardBorder-circle {
  border-radius: 50% !important;
}
img {
  width: 100%;
  padding: 10px;
  border-radius: 50%;
}
</style>